import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import STYLES from './PriceMarker.module.scss';

type Props = {
  price: string;
  locationId: string;
  onLocationClicked: (key: string) => void;
};

const PriceMarker = ({ locationId, onLocationClicked, price }: Props) => {
  const onMarkerClick = () => onLocationClicked(locationId);

  return (
    <div className={STYLES.PriceMarker}>
      <div
        className={STYLES.PriceMarker__marker}
        onClick={onMarkerClick}
        onKeyDown={onMarkerClick}
        onMouseDown={(e) => e.preventDefault()}
        role="button"
        tabIndex={0}
      >
        <BpkText textStyle={TEXT_STYLES.label1} tagName="span">
          {price}
        </BpkText>
      </div>
    </div>
  );
};

export default PriceMarker;
